import React from 'react';
import '../assets/css/communication.css';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext';

function CommunicationPage() {
  const [t] = useTranslation("global");
  const { user } = useAuth();
  const isAdmin = !!user;

  return (
    <div className="communication-page">
      <Header isAdmin={isAdmin} />

      <section className="communication-information" id="main">
        {/* Full‐width title, but left‐aligned */}
        <h1 className="comm-title">
          {t('communication.title') /* e.g. “Contact info” */}
        </h1>

        {/* Row 1, Col 1 */}
        <div className="comm-section">
          <h3 className="section-title">{t('communication.phone_label')}</h3>
          <div className="section-content">
            <div>+380931303010</div>
          </div>
        </div>

        {/* Row 1, Col 2 */}
        <div className="comm-section">
          <h3 className="section-title">{t('communication.email_label')}</h3>
          <div className="section-content">
            <div>hammerstone.ua@gmail.com</div>
          </div>
        </div>

        {/* Row 2, Col 1 */}
        <div className="comm-section">
          <h3 className="section-title">{t('communication.messengers')}</h3>
          <div className="section-content">
            <a href="https://wa.me/+380931303010" target="_blank" rel="noopener noreferrer">WhatsApp</a>
            <a href="https://t.me/HAMMERSTONE_UA" target="_blank" rel="noopener noreferrer">Telegram</a>
            {/* <a href="https://viber/chat?number=%2B380931303010">Viber</a> */}
          </div>
        </div>

        {/* Row 2, Col 2 */}
        <div className="comm-section">
          <h3 className="section-title">{t('communication.socials')}</h3>
          <div className="section-content">
            <a href="https://www.facebook.com/share/1B3sRUfyHP/" target="_blank" rel="noopener noreferrer">Facebook</a>
            <a href="https://www.instagram.com/hammerstone.ua?igsh=MWcwYzI4YjZnd3VjdA==" target="_blank" rel="noopener noreferrer">Instagram</a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default CommunicationPage;
